export const MEDIA_TYPE_OPTIONS = [
  {
    label: 'Default',
    value: 'default',
  },
  {
    label: 'Developments',
    value: 'developments',
  },
  {
    label: 'Logos',
    value: 'logos',
  },
  {
    label: 'Company',
    value: 'company',
  },
]

export const assetIcon = (extension: string) => {
  console.log(extension)
  switch (extension) {
    case 'zip':
      return 'zip'
    case 'mp4':
    case 'avi':
      return 'video'
    case 'pdf':
    case 'doc':
      return 'pdf'
    case 'jpg':
    case 'jpeg':
    case 'png':
    case 'svg':
      return 'image'
    default:
      return 'zip'
  }
}
